import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { pageDefinition } from 'site-modules/shared/pages/page';
import { TrackingMap } from 'client/tracking/maps/dashboard/index';
import { insiderPage } from 'site-modules/profile/pages/common/insider-page/insider-page';
import { InsiderPageHeader } from 'site-modules/profile/components/shared/insider-page-header/insider-page-header';
import { WelcomeText } from 'site-modules/profile/components/dashboard/welcome-text/welcome-text';
import { InsiderInventoryDashboard } from 'site-modules/profile/components/dashboard/insider-inventory-dashboard/insider-inventory-dashboard';
import { EdmundsCpaNoAdhesionDecorator } from 'site-modules/shared/pages/decorators/edmunds-cpa-no-adhesion';

export function DashboardPage({ isMobile, isAuthenticated = null, updateIdmData, removeDataFromIdm }) {
  return isMobile ? (
    <Fragment>
      {isMobile && <InsiderPageHeader customTitle="Dashboard" />}
      <WelcomeText isMobile />
    </Fragment>
  ) : (
    <div className="dashboard-default-spacing">
      <InsiderInventoryDashboard
        isAuthenticated={isAuthenticated}
        updateIdmData={updateIdmData}
        removeDataFromIdm={removeDataFromIdm}
        isMain
      />
    </div>
  );
}

DashboardPage.propTypes = {
  removeDataFromIdm: PropTypes.func.isRequired,
  updateIdmData: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired,
};

const Dashboard = insiderPage(DashboardPage, {
  map: TrackingMap,
  parent: 'edm-entry-dashboard',
});

export default pageDefinition({
  name: 'dashboard_page',
  category: 'dashboard_page',
  component: Dashboard,
  decorator: EdmundsCpaNoAdhesionDecorator,
  seo: {
    title: 'Edmunds Insider Membership Dashboard',
    description:
      'Access your saved car-shopping data, receive price drop alerts, vehicle recommendations, and valuable tips.',
    robots: {
      noFollow: true,
      noIndex: true,
    },
  },
});
